import styled from 'styled-components'

export const PaginationContainer = styled.div`
  margin-top: ${props => props.theme.spacing.sp24};
  padding-top: ${props => props.theme.spacing.sp24};
  border-top: ${props => props.theme.stroke.default} solid ${props => props.theme.colors.border.default};
  display: flex;
  justify-content: flex-end;
`

export const InvoicesContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp16};
`
